import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import HomeScreen from "./pages/HomeScreen";
import AdminPage from "./pages/AdminPage";
import ScreenSaver from "./components/ScreenSaver";

function App() {
  return (
    <Router>
      <ScreenSaver />
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </Router>
  );
}

export default App;

